import { render } from "./OrderComponent.vue?vue&type=template&id=684c8a14&scoped=true"
import script from "./OrderComponent.vue?vue&type=script&lang=js"
export * from "./OrderComponent.vue?vue&type=script&lang=js"

import "./OrderComponent.vue?vue&type=style&index=0&id=684c8a14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684c8a14"]])

export default __exports__